import apolloClient from '@/store/apollo';

import BookingGql from '@/store/graphql/extensions/eventManager/mutations/Booking.gql';

export default {
    create: booking =>
        new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: BookingGql,
                    variables: { booking }
                })
                .then(({ data }) => resolve(data.EX_EVNT_CreateBooking))
                .catch(error => reject(error.message));
        })
};
